import { ShowErrorFunc, ShowErrorProps } from './types';

export const showErrorOnChange: ShowErrorFunc = (meta: ShowErrorProps) =>
  !!((meta.submitError || meta.error) && (meta.touched || meta.dirty));

/**
 * final-form records field-level validation errors of nested child fields
 * under the parent's path, so `meta.error` on a wrapper's field can be a
 * record of child errors (e.g. `{ ackPolicy: '…' }`) instead of a message.
 * Only primitives are renderable as this field's own error — nested records
 * belong to the child controls, which render their own errors.
 *
 * Yup-based validators (`makeValidateSync`) map each field's messages to an
 * array (`set(errors, path, [message])`), so a single-message array is
 * unwrapped to its first renderable element; multi-message arrays render the
 * first one rather than nothing.
 */
export const resolveRenderableError = (
  error: unknown
): string | number | undefined => {
  if (typeof error === 'string' || typeof error === 'number') {
    return error;
  }

  if (Array.isArray(error)) {
    return error.find(
      (item): item is string | number =>
        typeof item === 'string' || typeof item === 'number'
    );
  }

  return undefined;
};
